module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1534-5d426497ba755949cb7d8b3dfba0f5f7.png";